module.exports = __webpack_public_path__ + "static/media/opResult.f577724d.png";